import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import appStore from '@/assets/images/wreg/market-appstore.svg';
import googlePlay from '@/assets/images/wreg/market-google.svg';
import { chatBotManager } from '@/services/chatBotManager';
import { RIcon } from '../RIcon';
import { WregPhase } from '../WregPhase';

type Props = {
  onEnter: () => void;
};

const ITEMS = ['wreg.allset.item1', 'wreg.allset.item2', 'wreg.allset.item3'] as const;

const WregAllSet = ({ onEnter }: Props) => {
  const { t } = useTranslation();

  useEffect(() => {
    chatBotManager.setWidgetVisibility(false);
    return () => chatBotManager.setWidgetVisibility(true);
  }, []);

  return (
    <div className="rg-screen">
      <div className="rg-body">
        <div className="rg-inner" style={{ alignItems: 'stretch' }}>
          <div className="rg-head-block">
            <WregPhase n={5} />
            <h1 className="rg-h1">{t('wreg.allset.title')}</h1>
          </div>
          <div className="rg-handoff-list">
            {ITEMS.map((key) => (
              <div className="rg-handoff-item" key={key}>
                <span className="rg-handoff-tick">
                  <RIcon.checkFill />
                </span>
                {t(key)}
              </div>
            ))}
          </div>
          <div className="rg-store-row">
            <button type="button" className="dsb dsb-store dsb-m dsb-block" onClick={onEnter}>
              <img src={appStore} alt={t('wreg.allset.appstore')} width="150" height="39" />
            </button>
            <button type="button" className="dsb dsb-store dsb-m dsb-block" onClick={onEnter}>
              <img src={googlePlay} alt={t('wreg.allset.googleplay')} width="174" height="42" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export { WregAllSet };
